import React from "react";
import { List, Image } from "semantic-ui-react";

export default function AllergensSummaryList({ allergens }) {
  return (
    <List verticalAlign="middle">
      {allergens.map((allergen, i) => {
        return (
          <List.Item key={i}>
            <Image avatar src={allergen.node.icon} />
            <List.Content>
              <List.Item>{allergen.node.name}</List.Item>
            </List.Content>
          </List.Item>
        );
      })}
    </List>
  );
}
